import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import Img1 from "../../Assets/Images/img1.png";

const ContactUs = () => {
  return (
    <div className="bg-white rounded-md shadow p-4 text-center relative">
      {/* Image */}
      <img src={Img1} alt="Service Person" className="w-full rounded-md" />

      {/* Floating WhatsApp Icon */}
      <div className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#E8471B] w-12 h-12 flex items-center justify-center rounded-full text-white text-lg">
        <FaWhatsapp />
      </div>

      {/* Text */}
      <p
        className="mt-12 font-orbitron font-semibold text-[#030B25] text-center align-middle capitalize
        text-[20px] sm:text-[22px] md:text-[24px]
        leading-[120%] sm:leading-[125%] md:leading-[130%]
        tracking-[0.5px]"
      >
        Need Any Service Or Product, Feel Free To Call Us
      </p>

      {/* Button */}
      <button
        className="mt-4 bg-[#02081A] text-white px-6 py-2 rounded font-quicksand font-semibold text-center align-middle capitalize
        text-[14px] sm:text-[15px] md:text-[16px]
        leading-[22px] sm:leading-[24px] md:leading-[27px]
        tracking-[0.37px]"
        onClick={() => {
          const phoneNumber = "+91 7017774127";
          const whatsappUrl = `https://wa.me/${phoneNumber}`;
          window.open(whatsappUrl, "_blank");
        }}
      >
        WhatsApp Us
      </button>
    </div>
  );
};

export default ContactUs;
